import { getSourceList } from 'api/source/index';
const state = {
  sourcesList: [], //广告主ID
  sourcesNameList: [], //广告主ID
  // 原始数据
  originSourceList: [],
  sourceLoading: false, //广告主下拉loading
};
const mutations = {
  SET_SOURCE_LIST: (state, sourcesList) => {
    state.sourcesList = sourcesList;
  },
  SET_SOURCE_NAME_LIST: (state, sourcesNameList) => {
    state.sourcesNameList = sourcesNameList;
  },
  SET_SOURCE_LOADING: (state, sourceLoading) => {
    state.sourceLoading = sourceLoading;
  },
  SET_ORIGIN_SOURCE: (state, sourcesList) => {
    state.originSourceList = sourcesList;
  },
};
const actions = {
  async getSourceIdsList({ state, commit }) {
    if (state['sourceLoading'] === true) {
      return;
    }
    commit('SET_SOURCE_LOADING', true);

    const response = await getSourceList();
    commit('SET_SOURCE_LOADING', false);
    let sourcesList = [];
    let sourcesNameList = [];
    if (response.code === 200) {
      let sourceIds = response.result;

      commit('SET_ORIGIN_SOURCE', sourceIds);
      const CPIGorups = {
        id: 1,
        checked: false,
        label: 'CPI',
        children: [],
      };

      const CPAGorups = {
        id: 2,
        checked: false,
        label: 'CPA',
        children: [],
      };
      const SmartLinkGroups = {
        id: 3,
        checked: false,
        label: 'SmartLink',
        children: [],
      };

      const CPLGroups = {
        id: 4,
        checked: false,
        label: 'CPL',
        children: [],
      };

      const PausedPending = {
        id: 5,
        checked: false,
        label: 'Paused&Pending',
        children: [],
      };

      const CPIGorupsName = {
        id: 1,
        checked: false,
        label: 'CPI',
        children: [],
      };

      const CPAGorupsName = {
        id: 2,
        checked: false,
        label: 'CPA',
        children: [],
      };
      const SmartLinkGroupsName = {
        id: 3,
        checked: false,
        label: 'SmartLink',
        children: [],
      };

      const CPLGroupsName = {
        id: 4,
        checked: false,
        label: 'CPL',
        children: [],
      };

      const PausedPendingName = {
        id: 5,
        checked: false,
        label: 'Paused&Pending',
        children: [],
      };
      sourceIds.forEach((item) => {
        if (item.enable !== 'ENABLE') {
          PausedPending.children.push({
            id: item.id,
            value: item.id,
            label: `${item.id} - ${item.company}`,
          });
          PausedPendingName.children.push({
            id: item.id,
            value: item.company,
            label: item.company,
          });
        } else if (item.payoutType == 'CPI') {
          CPIGorups.children.push({
            id: item.id,
            value: item.id,
            label: `${item.id} - ${item.company}`,
          });
          CPIGorupsName.children.push({
            id: item.id,
            value: item.company,
            label: item.company,
          });
        } else if (item.payoutType == 'CPA') {
          CPAGorups.children.push({
            id: item.id,
            value: item.id,
            label: `${item.id} - ${item.company}`,
          });
          CPAGorupsName.children.push({
            id: item.id,
            value: item.company,
            label: item.company,
          });
        } else if (item.payoutType == 'CPL') {
          CPLGroups.children.push({
            id: item.id,
            value: item.id,
            label: `${item.id} - ${item.company}`,
          });
          CPLGroupsName.children.push({
            id: item.id,
            value: item.company,
            label: item.company,
          });
        }
      });
      sourcesList.push(CPIGorups, CPAGorups, SmartLinkGroups, CPLGroups, PausedPending);
      sourcesNameList.push(
        CPIGorupsName,
        CPAGorupsName,
        SmartLinkGroupsName,
        CPLGroupsName,
        PausedPendingName
      );
    }
    commit('SET_SOURCE_LIST', sourcesList);
    commit('SET_SOURCE_NAME_LIST', sourcesNameList);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
